import { Skeleton } from '@delmonicos/shared-design-system-react/src/components/skeleton/skeleton';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

export const InformationTabLoadingComponent = (): React.JSX.Element => {
  return (
    <Stack gap={GapEnum.L} flex={1}>
      <Stack gap={GapEnum.M} direction="column" flex={1}>
        <Skeleton flex={1} />
      </Stack>
      <Stack gap={GapEnum.M} direction="column" flex={1}>
        <Skeleton flex={1} />
        <Skeleton flex={1} />
      </Stack>
    </Stack>
  );
};
